import { Box, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ICustomerActivitySummary } from 'src/generated-types'
import { ReactComponent as DeviationIcon } from '../../assets/svg/deviation.svg'
import { ReactComponent as DocumentIcon } from '../../assets/svg/documents-icon.svg'
import { ReactComponent as MaintenanceIcon } from '../../assets/svg/maintenance.svg'
import CountWithIconBox from '../common/CountWithIconBox'
import { Spinner } from '../Spinner'
import { CommonInterface } from './CustomerHeader'

const HeaderMaintenanceIcon = () => <MaintenanceIcon width={16} height={16} />
const HeaderDeviationIcon = () => <DeviationIcon width={16} height={16} />
const HeaderDocumentIcon = () => <DocumentIcon width={12} height={12} />

interface customerLocalitiesStatusInterface {
  customerActivitySummaryData?: ICustomerActivitySummary
  loading?: boolean
}

const CustomerLocalitiesStatus: React.FC<customerLocalitiesStatusInterface & CommonInterface> = ({
  customerActivitySummaryData,
  isLandingPage,
  loading,
}) => {
  const { t } = useTranslation('common')
  const theme = useTheme()
  return loading ? (
    <Box
      className={`flex ${isLandingPage ? 'flex-wrap justify-end' : 'nowrap'}`}
      width={'100px'}
      marginTop={'3px'}
      alignContent={'center'}
      justifyContent={'center'}
    >
      <Spinner size={'15px'} />
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'flex-end',
        width: 'auto',
        minWidth: 'max-content',
        marginTop: '3px',
        flexShrink: 0,
      }}
    >
      <Box>
        <CountWithIconBox
          title={t('maintenance', { ns: 'common' })}
          Component={HeaderMaintenanceIcon}
          value={String(customerActivitySummaryData?.servicesCount ?? 0).padStart(3, '0')}
          iconBgColor={theme.palette.primaryDark[theme.palette.mode]}
          color={theme.palette.black[theme.palette.mode]}
          styles={{
            paddingRight: !isLandingPage ? '5px' : '6px',
            fontSize: isLandingPage ? '12px' : '11px',
            textAlign: 'left',
            paddingTop: isLandingPage ? '0px' : '1px',
          }}
          customChipWidth={'auto'}
        />
      </Box>
      <Box sx={{ paddingLeft: isLandingPage ? '8px' : '4px' }}>
        <CountWithIconBox
          title={t('deviations', { ns: 'common' })}
          Component={HeaderDeviationIcon}
          value={String(customerActivitySummaryData?.deviationsCount ?? 0).padStart(3, '0')}
          iconBgColor={theme.palette.errorMain[theme.palette.mode]}
          color={theme.palette.black[theme.palette.mode]}
          styles={{
            paddingRight: !isLandingPage ? '5px' : '6px',
            fontSize: isLandingPage ? '12px' : '11px',
            textAlign: 'left',
            paddingTop: isLandingPage ? '0px' : '1px',
          }}
          customChipWidth={'auto'}
        />
      </Box>
      <Box sx={{ paddingLeft: isLandingPage ? '8px' : '4px' }}>
        <CountWithIconBox
          title={t('documents', { ns: 'common' })}
          Component={HeaderDocumentIcon}
          value={String(customerActivitySummaryData?.documentsCount ?? 0).padStart(3, '0')}
          iconBgColor={theme.palette.primaryDark[theme.palette.mode]}
          color={theme.palette.black[theme.palette.mode]}
          styles={{
            paddingRight: !isLandingPage ? '5px' : '6px',
            fontSize: isLandingPage ? '12px' : '11px',
            textAlign: 'left',
            paddingTop: isLandingPage ? '0px' : '1px',
          }}
          customChipWidth={'auto'}
        />
      </Box>
    </Box>
  )
}

export default CustomerLocalitiesStatus
